import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import SwiperCore, {
  Autoplay,
  Navigation,
  Pagination,
  SwiperOptions
} from 'swiper';
import { IVideo } from '../../interfaces/videosByCategory';

SwiperCore.use([Navigation, Pagination, Autoplay]);

@Component({
  selector: 'app-main-carousel',
  templateUrl: './main-carousel.component.html',
  styleUrls: ['./main-carousel.component.scss']
})
export class MainCarouselComponent implements OnChanges {
  @Input() slides: IVideo[] = [];

  swiperConfig: SwiperOptions = this.buildConfig();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['slides']) {
      this.swiperConfig = this.buildConfig();
    }
  }

  private buildConfig(): SwiperOptions {
    const hasMultiple = this.slides.length > 1;
    return {
      slidesPerView: 1,
      navigation: {
        nextEl: '.arrow-icon.right',
        prevEl: '.arrow-icon.left'
      },
      pagination: { clickable: true },
      loop: hasMultiple,
      autoplay: hasMultiple ? { delay: 5000, disableOnInteraction: false } : false
    };
  }
}
